export default "__VITE_ASSET__bb7f67d3__"